<p-drawer
  [visible]="display"
  position="right"
  (onHide)="onHide()"
  appendTo="body"
  header="Add note for {{ saleOrderId }}"
  class="sidebarWidth">
  <div class="mb-2 left-sidebar">
    <form [formGroup]="saleOrderNoteForm">
      <div class="form-group has-float-label mb-2">
        <label class="form-label"
          >Type <span class="madatory-field">*</span></label
        >
        <p-select
          pInputText
          [(ngModel)]="defaultTypeSelection"
          (onChange)="onPurchaseOrderSelection(defaultTypeSelection)"
          formControlName="type"
          [options]="typeList"
          optionLabel="name"
          optionValue="name">
        </p-select>
      </div>
      <div
        class="col-12 mb-2"
        *ngIf="!isFromInvoiceSummary && orderType !== 'inventory-sales'">
        <div class="switcher">
          <div class="form-label mb-1">Purchase Order:</div>
          <div class="d-flex align-items-center form-switch gap-2">
            <p-toggleswitch
              formControlName="purchaseOrderStatus"
              (change)="openPurchaseOrder($event)"
              id="flexSwitchCheckDefault2" />

            <label class="form-check-label">
              {{ this.saleOrderNoteForm.get("purchaseOrderStatus")?.value }}
            </label>
          </div>
        </div>
      </div>
      <div
        class="form-group has-float-label mb-2"
        [hidden]="numberFieldStatus"
        *ngIf="!isFromInvoiceSummary">
        <label class="form-label"
          >Number <span *ngIf="ispurchaseOrderIdField">*</span></label
        >
        <p-select
          pInputText
          [(ngModel)]="defaultPurchaseOrderSelection"
          formControlName="purchaseOrderId"
          [options]="purchaseOrderNumber">
        </p-select>
      </div>
      <div class="col-12 mb-2">
        <div class="has-float-label">
          <label class="form-label"
            >Description<span class="madatory-field">*</span></label
          >
          <input
            pInputText
            jniAutoCompleteBlocker
            name="Description"
            type="text"
            class="form-control"
            maxlength="120"
            formControlName="description" />
        </div>
      </div>
      <div class="col-12 mb-2">
        <div class="has-float-label">
          <label class="form-label">Notes</label>
          <textarea
            pInputText
            jniAutoCompleteBlocker
            name="Notes"
            type="text"
            class="form-control"
            rows="8"
            formControlName="note"></textarea>
        </div>
      </div>
    </form>

    <div>
      <p-button
        label="save"
        [disabled]="!saleOrderNoteForm.valid"
        (click)="onSaleOrderNotesSave()" />
    </div>
  </div>
</p-drawer>
